import { useState, useEffect, useMemo } from 'react';
export const useResponsive = () => {
    const [screenDimensions, setScreenDimensions] = useState({
        width: typeof window !== 'undefined' ? window.innerWidth : 0,
        height: typeof window !== 'undefined' ? window.innerHeight : 0,
    });
    useEffect(() => {
        const handleResize = () => {
            setScreenDimensions({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const isMobile = useMemo(() => screenDimensions.width < 768, [screenDimensions.width]);
    const isTablet = useMemo(() => screenDimensions.width >= 768 && screenDimensions.width < 1024, [screenDimensions.width]);
    const isDesktop = useMemo(() => screenDimensions.width >= 1024, [screenDimensions.width]);
    const deviceType = useMemo(() => {
        if (isMobile)
            return 'mobile';
        if (isTablet)
            return 'tablet';
        return 'desktop';
    }, [isMobile, isTablet]);
    return {
        isMobile,
        isTablet,
        isDesktop,
        deviceType,
        screenWidth: screenDimensions.width,
        screenHeight: screenDimensions.height,
    };
};
//# sourceMappingURL=useResponsive.js.map